/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddEmployeeLogModel as DigiworkMaitreDPosDtoEmployeeAddEmployeeLogModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Employee/add-employee-log-model';

export interface AddEmployeeLog$Params {
      body?: DigiworkMaitreDPosDtoEmployeeAddEmployeeLogModel
}

export function addEmployeeLog(http: HttpClient, rootUrl: string, params?: AddEmployeeLog$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addEmployeeLog.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addEmployeeLog.PATH = '/api/mng/Employee/addemployeelog';
